import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinkathwadagidc() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Kathwada GIDC Ahmedabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Kathwada GIDC Ahmedabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Kathwada GIDC Ahmedabad, catering to the transportation needs of industrial units, manufacturing plants, warehouses, and corporate offices across the region. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, supervisors, clients, and senior executives. Whether it is daily staff commute, plant visits, airport transfers, business meetings, inter-office travel, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited guarantees a premium and dependable corporate travel experience for businesses operating in and around Kathwada GIDC Ahmedabad.',

    top: 'Top Places to Visit in Ahmedabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Sabarmati Ashram",
    "description": "Sabarmati Ashram, located on the banks of the Sabarmati River, was the home of Mahatma Gandhi for over a decade and served as a major center for the Indian freedom movement. Visitors can explore Gandhi’s simple living quarters, archives of letters, photographs, and exhibits explaining India’s struggle for independence. The peaceful environment, museum, and historical displays make it a place of deep reflection and national pride."
  },
  {
    "title": "Sidi Saiyyed Mosque",
    "description": "The Sidi Saiyyed Mosque, built in 1573 during the Gujarat Sultanate period, is renowned for its iconic stone latticework windows known as the 'Sidi Saiyyed Jali'. These intricately carved screens depicting the famous ‘Tree of Life’ are considered masterpieces of Indo-Islamic art. The mosque offers visitors a chance to admire historic craftsmanship and experience one of Ahmedabad’s most recognized architectural symbols."
  },
  {
    "title": "Sabarmati Riverfront",
    "description": "Sabarmati Riverfront is a beautiful riverside development project that has transformed Ahmedabad’s waterfront into a vibrant public space. Featuring pedestrian walkways, gardens, cycling tracks, boating facilities, and event spaces, the riverfront is ideal for family outings, leisure walks, and evening relaxation. The well-maintained urban landscape and scenic views make it a preferred hangout spot for locals and tourists."
  },
  {
    "title": "Adalaj Stepwell",
    "description": "Adalaj Stepwell, located just outside Ahmedabad, is a centuries-old five-story stepwell built in 1498 in Indo-Islamic architectural style. Known for its beautifully carved pillars, ornamental walls, and cooling subterranean design, the stepwell served as a resting place for travelers in earlier times. Today, it stands as an engineering and artistic marvel, offering visitors a glimpse into Gujarat’s architectural heritage."
  },
  {
    "title": "Kankaria Lake",
    "description": "Kankaria Lake is a large man-made lake that has evolved into one of Ahmedabad’s most popular recreational hubs. Surrounding the lake are amusement rides, toy trains, food stalls, a zoo, children’s play zones, and water activities, making it ideal for families. The illuminated musical fountain shows and clean walking paths make evenings at Kankaria lively and memorable."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, built in 1424 by Sultan Ahmed Shah, is one of the most impressive mosques in Gujarat. Constructed from yellow sandstone, it features beautifully carved pillars, grand prayer halls, and a harmonious blend of Hindu and Islamic architectural influences. Visitors can explore the expansive courtyard and admire the detailed stonework, reflecting the historical importance of early Ahmedabad."
  },
  {
    "title": "Calico Museum of Textiles",
    "description": "The Calico Museum of Textiles is one of the finest textile museums in the world, preserving centuries of India’s weaving, dyeing, printing, and embroidery traditions. Exhibits include royal costumes, temple cloths, carpets, and antique fabrics displayed in well-curated galleries. Visitors can gain a deep understanding of India's rich textile heritage, craftsmanship, and cultural evolution."
  },
  {
    "title": "Auto World Vintage Car Museum",
    "description": "Auto World Vintage Car Museum houses one of India’s largest collections of classic automobiles, including limousines, sports cars, convertibles, and royal vehicles from Europe and America. Many cars belonged to Indian princely families and are preserved in running condition. The museum offers a nostalgic journey into the history of automotive engineering and luxury travel."
  },
  {
    "title": "Hutheesing Jain Temple",
    "description": "Built in 1848, Hutheesing Jain Temple is a beautifully crafted marble temple dedicated to Lord Dharmanath. The temple features ornate carvings, elaborately decorated domes, and peaceful prayer halls that showcase the artistic traditions of Jain architecture. It is a serene spiritual destination and a remarkable example of Ahmedabad’s religious heritage."
  },
  {
    "title": "Manek Chowk",
    "description": "Manek Chowk is Ahmedabad’s famous city square known for its unique transformation throughout the day: a bustling vegetable market in the morning, a jewelry hub during the day, and a thriving street food destination at night. Visitors can enjoy traditional Gujarati snacks, sweets, and freshly prepared dishes, making it a must-visit spot for food lovers seeking authentic local flavors."
  }
],


"services": [
  {
    "name": "Kathwada GIDC Employee Cab Ahmedabad",
    "description": "Kathwada GIDC Employee Cab Ahmedabad provides dedicated daily commute solutions for employees working in Kathwada GIDC. With professional drivers, GPS-enabled vehicles, and optimized routes, it ensures safe, timely, and reliable transport for industrial and corporate staff."
  },
  {
    "name": "Corporate Shuttle Kathwada GIDC Ahmedabad",
    "description": "Corporate Shuttle Kathwada GIDC Ahmedabad delivers high-capacity shuttle services for companies with large workforces. Featuring AC minibuses, multi-shift support, route optimization, and real-time tracking, it ensures smooth, organized, and safe commuting within Kathwada GIDC."
  },
  {
    "name": "Industrial Cab Kathwada Ahmedabad",
    "description": "Industrial Cab Kathwada Ahmedabad provides specialized transportation for industrial employees. The service includes well-maintained vehicles, trained drivers, and structured routes for safe and efficient daily commuting."
  },
  {
    "name": "Factory Staff Transport Kathwada GIDC Ahmedabad",
    "description": "Factory Staff Transport Kathwada GIDC Ahmedabad offers organized transport solutions for factory workers. With dedicated shuttles, pre-planned schedules, and professional chauffeurs, it ensures punctual, secure, and dependable commuting."
  },
  {
    "name": "Monthly Cab Kathwada GIDC Ahmedabad",
    "description": "Monthly Cab Kathwada GIDC Ahmedabad provides contract-based, long-term employee transportation. It includes dedicated vehicles, trained drivers, route planning, and GPS monitoring to ensure uninterrupted and cost-effective monthly commute."
  },
  {
    "name": "Business Cab Kathwada GIDC Ahmedabad",
    "description": "Business Cab Kathwada GIDC Ahmedabad delivers premium travel services for corporate meetings, client visits, and inter-office trips. Featuring sedans and SUVs with professional chauffeurs, it ensures comfort, reliability, and punctuality."
  },
  {
    "name": "Affordable Cab Kathwada GIDC Ahmedabad",
    "description": "Affordable Cab Kathwada GIDC Ahmedabad offers cost-effective corporate transportation without compromising safety or comfort. Ideal for SMEs and mid-sized factories, it ensures efficient daily commuting for employees."
  },
  {
    "name": "Best Corporate Cab Kathwada GIDC Ahmedabad",
    "description": "Best Corporate Cab Kathwada GIDC Ahmedabad provides premium-grade transport services with high-quality vehicles, professional drivers, and superior safety standards. It is suitable for executives, managers, and VIP staff seeking a refined travel experience."
  },
  {
    "name": "Outstation Cab Kathwada GIDC Ahmedabad",
    "description": "Outstation Cab Kathwada GIDC Ahmedabad offers long-distance corporate travel solutions for business trips, client visits, and factory tours. It includes comfortable sedans and SUVs, experienced chauffeurs, interstate permits, and live tracking."
  },
  {
    "name": "Sedan Cab Kathwada GIDC Ahmedabad",
    "description": "Sedan Cab Kathwada GIDC Ahmedabad provides executive sedans ideal for managerial commute, airport transfers, and business visits. Vehicles are well-maintained and driven by trained professionals for a comfortable, safe, and punctual experience."
  },
  {
    "name": "SUV Cab Kathwada GIDC Ahmedabad",
    "description": "SUV Cab Kathwada GIDC Ahmedabad delivers spacious and premium SUVs suitable for senior executives, team travel, and long-distance trips. The service emphasizes comfort, reliability, and professional chauffeur service."
  },
  {
    "name": "Company Cab Kathwada Ahmedabad",
    "description": "Company Cab Kathwada Ahmedabad offers comprehensive corporate transport solutions including employee, executive, and visitor travel. Services include fleet management, driver coordination, vehicle maintenance, and safe, reliable transport operations."
  },
  {
    "name": "Employee Mobility Kathwada Ahmedabad",
    "description": "Employee Mobility Kathwada Ahmedabad provides tech-enabled and flexible commuting solutions, supporting multi-shift schedules, GPS tracking, and real-time fleet coordination for seamless, safe, and reliable transport within Kathwada GIDC."
  },
  {
    "name": "Staff Pickup Drop Kathwada GIDC Ahmedabad",
    "description": "Staff Pickup Drop Kathwada GIDC Ahmedabad offers scheduled pick-up and drop services for employees with fixed and flexible routes, professional drivers, and GPS-enabled monitoring to ensure punctual, safe, and efficient staff transport."
  },
  {
    "name": "Corporate Fleet Kathwada GIDC Ahmedabad",
    "description": "Corporate Fleet Kathwada GIDC Ahmedabad provides end-to-end fleet management solutions for organizations, including sedans, SUVs, and shuttle vehicles. Services cover driver management, vehicle maintenance, compliance, GPS tracking, and scalable fleet availability for corporate operations."
  }
],

"tableData": [
  ["Kathwada GIDC Employee Cab Ahmedabad", "Corporate Shuttle Kathwada GIDC Ahmedabad"],
  ["Industrial Cab Kathwada Ahmedabad", "Factory Staff Transport Kathwada GIDC Ahmedabad"],
  ["Monthly Cab Kathwada GIDC Ahmedabad", "Business Cab Kathwada GIDC Ahmedabad"],
  ["Affordable Cab Kathwada GIDC Ahmedabad", "Best Corporate Cab Kathwada GIDC Ahmedabad"],
  ["Outstation Cab Kathwada GIDC Ahmedabad", "Sedan Cab Kathwada GIDC Ahmedabad"],
  ["SUV Cab Kathwada GIDC Ahmedabad", "Company Cab Kathwada Ahmedabad"],
  ["Employee Mobility Kathwada Ahmedabad", "Staff Pickup Drop Kathwada GIDC Ahmedabad"],
  ["Corporate Fleet Kathwada GIDC Ahmedabad", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Kathwada GIDC Ahmedabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Kathwada GIDC Ahmedabad, ensuring smooth and efficient transportation for employees and business executives across the industrial and commercial zones."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Kathwada GIDC and surrounding industrial areas, helping employees reach offices, factories, and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our skilled chauffeurs provide safe, courteous, and disciplined travel, ensuring a secure and comfortable commute for corporate passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Kathwada GIDC."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored cab rental plans to meet the commuting requirements of companies and employees in Kathwada GIDC Ahmedabad."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, offering secure, hygienic, and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is simplified through our streamlined booking system and reliable coordination, making employee transport hassle-free."
  }
]


























  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Kathwada GIDC, Ahmedabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and industrial offices in Kathwada GIDC, Ahmedabad.',
  },
  {
    question: 'What types of corporate transportation services are available in Kathwada GIDC?',
    answer: 'We provide employee transportation, industrial shuttle services, corporate pickups and drops, airport transfers, and full fleet management solutions for corporate and industrial clients.',
  },
  {
    question: 'Do you support daily employee commute services in Kathwada GIDC?',
    answer: 'Yes, we offer structured daily commute services with optimized routes, timely pickups, and multi-shift support for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Kathwada GIDC?',
    answer: 'Companies can book via our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Kathwada GIDC?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, tempo travellers, luxury cars, and electric vehicles depending on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Kathwada GIDC?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and comprehensive fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs to ensure maximum safety.',
  },
  {
    question: 'Do you provide transportation for night shifts and rotational shifts in Kathwada GIDC?',
    answer: 'Absolutely. We offer reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ankit Bhatt',
    feedback: 'Very reliable corporate cab service for our Kathwada GIDC office. Vehicles are clean and drivers are professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meenal Patel',
    feedback: 'Excellent corporate transportation partner. Our employees appreciate the smooth, safe, and timely commute services.',
    rating: 5,
  },
];













































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Kathwada GIDC Ahmedabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-kathwada-gidc.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited offers professional corporate cab services in Kathwada GIDC Ahmedabad, including employee cabs, corporate shuttle, industrial cab services, factory staff transport, monthly corporate cab rentals, business cabs, outstation trips, sedan & SUV corporate cabs, staff pickup & drop, employee mobility, and complete corporate fleet solutions.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-kathwada-gidc-ahmedabad"
  }
};




  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Kathwada GIDC Ahmedabad | Employee & Industrial Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Kathwada GIDC Ahmedabad including employee cabs, corporate shuttle, industrial cab services, factory staff transport, monthly corporate cab rentals, business cabs, outstation trips, sedan & SUV corporate cabs, staff pickup & drop, employee mobility, and complete corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="Kathwada GIDC Employee Cab Ahmedabad, Corporate Shuttle Kathwada GIDC Ahmedabad, Industrial Cab Kathwada Ahmedabad, Factory Staff Transport Kathwada GIDC Ahmedabad, Monthly Cab Kathwada GIDC Ahmedabad, Business Cab Kathwada GIDC Ahmedabad, Affordable Cab Kathwada GIDC Ahmedabad, Best Corporate Cab Kathwada GIDC Ahmedabad, Outstation Cab Kathwada GIDC Ahmedabad, Sedan Cab Kathwada GIDC Ahmedabad, SUV Cab Kathwada GIDC Ahmedabad, Company Cab Kathwada Ahmedabad, Employee Mobility Kathwada Ahmedabad, Staff Pickup Drop Kathwada GIDC Ahmedabad, Corporate Fleet Kathwada GIDC Ahmedabad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/89.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinkathwadagidc;